import FJActionConstant from "../../constant/FJActionConstant";
import FJViewConstant from "../../constant/FJViewConstant";

const initState = {
  zoomScale: 100,
  mediaStatus: FJViewConstant.MEDIA_STATUS_SUCCESS,
	mediaName: ''
};

export default function (state = initState, action) {
  switch (action.type) {
    case FJActionConstant.SET_PHOTO_ZOOM_SCALE:
      return {
        ...state,
        zoomScale: action.zoomScale,
      };
    case FJActionConstant.SET_PHOTO_MEDIA_STATUS:
      return {
        ...state,
        mediaStatus: action.mediaStatus,
      }
		case FJActionConstant.SET_IMAGE_MEDIA_NAME:
			return {
				...state,
				mediaName: action.mediaName
			}
    default:
      return state;
  }
}
